/**
 * api 파일들 일괄 등록
 */

import Vue from "vue";

const getRoutes = require.context("/", false, /[\w-].ts$/);
const api = getRoutes
  .keys()
  .reduce((obj: { [key: string]: object }, name: string) => {
    const route = getRoutes(name);
    name = name.replace("./", "").split(".")[0];
    if (name === "index") return obj;
    obj[name] = route.default;
    return obj;
  }, {});

Vue.prototype.$wApi = api;

const process = Vue.observable({
  items : [] , 
  localStorageKey : '' , 
  set () {
    let { localStorageKey , items } = process ; 
    localStorage.setItem( localStorageKey, JSON.stringify(items)) ; 
  } , 
  update ( crntItem : any ) {
    let { items } = process ; 
    let crntIdx : number = 0 ; 
    items.map(( item : any , idx ) => {
      if ( item.processId == crntItem.processId ) {
        crntIdx = idx ; 
      } 
    }) ; 
    process.set() ; 
  } , 
  get () {} , 
  open ( item : any ) {
    let items : any[] = process.items

    // 기존 목록에 있는가?
    if ( !items ) return ; 
    const exists = items.findIndex(({ processId }) => +item.processId === +processId) > -1;

    if ( exists ) {
      // console.log( 'exists' )
      items = items.map((origin) =>+item.processId === +origin.processId ? item : origin);
    } else {
      // console.log( 'none exists' )
      items.unshift( item ) ; 
    }

    process.set() ; 
  } , 
  close () {} , 
}) ; 
Vue.prototype.$process = process;

/* 
const locker = Vue.observable({
  locked: false,
  
  lock () {
    locker.locked = true;
    document.documentElement.classList.add('no-scroll');  
  },
  
  unlock () {
    locker.locked = false;
    document.documentElement.classList.remove('no-scroll');
  }
});

Vue.prototype.$bodyLocker = locker; 
*/


export default api;
